import $ from 'jquery'
import EE from '../helpers/ee'

function panelIsOpen(panel) {
  return panel.hasClass('sliding-panel--open')
}

function removeBodyPanelClass(panel) {
  $("[data-panel-name]").not(panel)
    .removeClass('sliding-panel--open')
  $('body').removeClass(function (index, className) {
    return (className.match(/(^|\s)panel-\S+/g) || []).join(' ');
  });
}

function closePanel(panel) {
  removeBodyPanelClass(panel)
  panel.removeClass('sliding-panel--open')

  EE.emit('no-scroll-off')
}
function openPanel(panel) {
  removeBodyPanelClass(panel)
  panel.addClass('sliding-panel--open')
  $('body').addClass('panel-is-open').addClass('panel-'+panel.attr('data-panel-name')+'-is-open')

  EE.emit('no-scroll-on')
}

function togglePanel(panel) {
  if (panelIsOpen(panel)) {
    closePanel(panel)
  } else {
    openPanel(panel)
  }
}

function targetInterfacesWithPanels(target){
  if(
    $(target).closest("[data-panel-name]").length > 0 ||
    $(target).closest("[data-panel-link]").length > 0
  ){
    return true;
  }
  return false;
}

function shouldClosePanel(allPanels) {
  for (let i = 0; i < allPanels.length; i++) {
    let panel = $(allPanels[i]);
    if (panelIsOpen(panel)) {
      closePanel(panel)
    }
  }
}

export function panelHandlers() {
  const allPanels = $('[data-panel-name]')
  const allButtons = $('[data-panel-link]')
  $('.sliding-panel-toggle').on('click', function(e){
    e.preventDefault();
    if (e.ctrlKey) {
      location.href = $(this).attr('href')
      console.warn('crtl click didn\'t not open in new tab. \n This feature is here for dev testing only! please delete at a later date.')
    }

    const button = $(this)
    const panelName = button.attr('data-panel-link')
    const panel = $('[data-panel-name="'+panelName+'"]')
    const action = button.attr('data-panel-action')

    switch(action) {
      case 'open':
        closePanel(panel)
        break;
      case 'close':
        openPanel(panel)
        break;
      case 'toggle':
        togglePanel(panel)
        break;
      default:
        togglePanel(panel)
    }
  })
  $(document).on('click', function(e) {
    if (!targetInterfacesWithPanels(e.target)) {
      shouldClosePanel(allPanels)
    }
    return;
  })
}


// WEBPACK FOOTER //
// ./assets/js/panel/panel.js